import { combineReducers } from 'redux';

import { searchReducer } from './search';
import { mapReducer } from './map';
import { geojsonReducer } from './geojson/reducer';

export default combineReducers({
  search: searchReducer,
  geojson: geojsonReducer,
  map: mapReducer,
});
